/**
 * Chat State Types and Initial State
 *
 * Defines all state types for the chat system
 */

import {
  Conversation,
  EnhancedMessage,
  ConversationFilters,
} from "@/types/centralizedChat";

export interface ChatState {
  // Conversations
  conversations: Conversation[];
  selectedConversation: Conversation | null;
  conversationFilters: ConversationFilters;

  // Messages
  messages: EnhancedMessage[];
  messagePagination: {
    currentPage: number;
    hasMore: boolean;
    totalPages: number;
    totalCount: number;
  } | null;

  // Notifications
  unreadCount: {
    total: number;
    byConversation: Record<string, number>;
  };
  notifications: Array<{
    id: string;
    ticketId: string;
    ticketTitle: string;
    senderName: string;
    senderRole: "customer" | "manufacturer" | "admin";
    content: string;
    createdAt: string;
    isRead: boolean;
  }>;

  // Loading states
  isLoadingConversations: boolean;
  isLoadingMessages: boolean;
  isLoadingMoreMessages: boolean;
  isSendingMessage: boolean;

  // Connection status
  isConnected: boolean;
  connectionStatus: "connected" | "connecting" | "disconnected" | "error";

  // Errors
  conversationsError: string | null;
  messagesError: string | null;

  // Metadata
  lastFetchTime: number | null;
}

export const initialChatState: ChatState = {
  conversations: [],
  selectedConversation: null,
  conversationFilters: {},
  messages: [],
  messagePagination: null,
  unreadCount: {
    total: 0,
    byConversation: {},
  },
  notifications: [],
  isLoadingConversations: false,
  isLoadingMessages: false,
  isLoadingMoreMessages: false,
  isSendingMessage: false,
  isConnected: false,
  connectionStatus: "disconnected",
  conversationsError: null,
  messagesError: null,
  lastFetchTime: null,
};
